<template>
  <div class="table">
    <a-tabs default-active-key="1" :animated="false">
      <a-tab-pane key="1" tab="基本配置">
        <div class="block_line"></div>
        <div class="headDiv">
          <a-select class="select" v-model="businssDeptId">
            <a-select-option value="">--请选择事业部--</a-select-option>
            <a-select-option v-for="item in businssDept" :value="item.id" :key="item.id">{{ item.name }}</a-select-option>
          </a-select>
          &nbsp;&nbsp;
          <a-button type="primary" @click="addData">新增</a-button>
        </div>
        <a-table style="overflow:auto" rowKey="id" :loading="loading" :dataSource="userList" :pagination="false">
          <a-table-column title="id" dataIndex="id" />
          <a-table-column title="内容名称" dataIndex="name" />
          <a-table-column title="所属业务" dataIndex="bussdepType">
            <template slot-scope="text">
              {{ filterType(text) }}
            </template>
          </a-table-column>
          <a-table-column
            title="所属事业部"
            dataIndex="bussdepId"
          ><template slot-scope="bussdepId">
            {{ filterApps(bussdepId) }}
          </template>
          </a-table-column>
          <a-table-column
            title="审核类型"
            dataIndex="auditType"
          ><template slot-scope="auditType">
            {{ filterStatus(auditType) }}
          </template>
          </a-table-column>
          <a-table-column title="标签列表接口" dataIndex="getlabelurl" />
          <a-table-column
            title="阿里云审核"
            dataIndex="aliyunAuditStatus"
            :width="100"
          ><template slot-scope="auditType">
            {{ auditType == 1 ? '开启' : '关闭' }}
          </template>
          </a-table-column>
          <a-table-column
            title="黑名单"
            dataIndex="blackStatus"
            :width="100"
          ><template slot-scope="auditType">
            {{ auditType == 1 ? '开启' : '关闭' }}
          </template>
          </a-table-column>
          <a-table-column
            title="白名单"
            dataIndex="whiteStatus"
            :width="100"
          ><template slot-scope="auditType">
            {{ auditType == 1 ? '开启' : '关闭' }}
          </template>
          </a-table-column>
          <a-table-column
            title="敏感词白名单"
            dataIndex="keyWordWhiteStatus"
            :width="100"
          ><template slot-scope="auditType">
            {{ auditType == 1 ? '开启' : '关闭' }}
          </template>
          </a-table-column>
          <a-table-column
            title="敏感词黑名单"
            dataIndex="keyWordStatus"
            :width="100"
          ><template slot-scope="auditType">
            {{ auditType == 1 ? '开启' : '关闭' }}
          </template>
          </a-table-column>
          <a-table-column
            title="智能短句"
            dataIndex="autoPhrasesStatus"
            :width="100"
          ><template slot-scope="auditType">
            {{ auditType == 1 ? '开启' : '关闭' }}
          </template>
          </a-table-column>

          <a-table-column
            title="操作"
            :width="100"
          ><template slot-scope="scope">
            <a @click="edit(scope)">编辑&nbsp;</a>
          </template>
          </a-table-column>
        </a-table>
      </a-tab-pane>
      <a-tab-pane key="2" tab="权限配置" force-render>
        <div class="block_line"></div>
        <div class="headDiv">
          <a-button @click="addauth" type="primary"><a-icon type="plus" />新建权限配置</a-button>
        </div>
        <a-table
          :columns="columns"
          :dataSource="authList"
          :loading="authloading"
          rowKey="id"
          :pagination="false"
        >
          <template slot="businessId" slot-scope="text, record">
            {{ filterType(record.businessId) }}
          </template>
          <template slot="operate" slot-scope="text, record">
            <div class="operate" @click="editauth(record)">编辑</div>
            <div class="operate" @click="configauth(record)">配置权限</div>
          </template>
        </a-table>
        <div style="margin:10px 0;text-align: right">
          <a-pagination
            :showSizeChanger="true"
            :showQuickJumper="true"
            @change="changePage"
            @showSizeChange="changeLimitNum"
            :show="pageObj.total > 0"
            :current="pageObj.current"
            :total="pageObj.total"
            :defaultPageSize="pageObj.pageSize"
            :showTotal="total => `总共 ${total} 条数据`"
          />
        </div>
      </a-tab-pane>
      <a-tab-pane key="3" tab="自定义配置">
        <div class="block_line"></div>
        <customConfig></customConfig>
      </a-tab-pane>
    </a-tabs>
    <a-modal
      :title="modifyId == -1 ? '新增配置' : '修改配置'"
      width="768px"
      @ok="handleOk"
      @cancel="cancelHandle"
      :visible="visible"
    >
      <a-form :form="form" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
        <a-form-item
          label="事业部"
          v-if="modifyId != -1 && userInfo().role == 'ROLE_SYSTEM'"
          :labelCol="{ span: 6 }"
          :wrapperCol="{ span: 16 }"
        >
          <a-select class="select" v-model="newData.bussdepId">
            <!--<a-select-option value="">&#45;&#45;请选择事业部&#45;&#45;</a-select-option>-->
            <a-select-option v-for="item in businssDept" :value="item.id" :key="item.id">{{
              item.name
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="内容名称">
          <a-input v-model="newData.name" />
        </a-form-item>
        <a-form-item label="所属业务">
          <a-select v-model="newData.bussdepType">
            <a-select-option value="">--请选择--</a-select-option>
            <a-select-option :value="item.key" v-for="item in bussdepType" :key="item.key">{{
              item.value
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="审核类型">
          <a-select v-model="newData.auditType">
            <a-select-option value="">--请选择--</a-select-option>
            <a-select-option value="1">审核</a-select-option>
            <a-select-option value="2">质检</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="回调URL">
          <a-input v-model="newData.callbackurl" />
        </a-form-item>
        <a-form-item label="secret">
          <a-input :type="showPass ? 'password' : 'text'" v-model="newData.secret" />
          <a-button @click="showPass = !showPass">显示</a-button>
        </a-form-item>
        <a-form-item label="标签列表接口">
          <a-input v-model="newData.getlabelurl" />
        </a-form-item>

        <a-form-item label="系统自动审核配置" :required="true">
          <a-row>
            <a-col :span="6" :offset="1">阿里云审核</a-col>
            <a-col :span="17">
              <a-radio-group v-decorator="['aliyunAuditStatus', { initialValue: 1 }]">
                <a-radio :value="1">开启</a-radio>
                <a-radio :value="2">关闭</a-radio>
              </a-radio-group>
              <a-radio-group
                v-decorator="['aliyunAuditEffectScope', { initialValue: 0 }]"
                v-show="form.getFieldValue('aliyunAuditStatus') === 1"
              >
                <a-radio :value="0">全部开启</a-radio>
                <a-radio :value="1">仅老师发言</a-radio>
                <a-radio :value="2">仅用户发言</a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" :offset="1">敏感词白名单</a-col>
            <a-col :span="17">
              <a-radio-group v-decorator="['keyWordWhiteStatus', { initialValue: 1 }]">
                <a-radio :value="1">开启</a-radio>
                <a-radio :value="2">关闭</a-radio>
              </a-radio-group>
              <a-radio-group
                v-decorator="['keywordwhiteEffectScope', { initialValue: 0 }]"
                v-show="form.getFieldValue('keyWordWhiteStatus') === 1"
              >
                <a-radio :value="0">全部开启</a-radio>
                <a-radio :value="1">仅老师发言</a-radio>
                <a-radio :value="2">仅用户发言</a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" :offset="1">敏感词黑名单</a-col>
            <a-col :span="17">
              <a-radio-group v-decorator="['keyWordStatus', { initialValue: 1 }]">
                <a-radio :value="1">开启</a-radio>
                <a-radio :value="2">关闭</a-radio>
              </a-radio-group>
              <a-radio-group
                v-decorator="['keywordEffectScope', { initialValue: 0 }]"
                v-show="form.getFieldValue('keyWordStatus') === 1"
              >
                <a-radio :value="0">全部开启</a-radio>
                <a-radio :value="1">仅老师发言</a-radio>
                <a-radio :value="2">仅用户发言</a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" :offset="1">智能短句</a-col>
            <a-col :span="17">
              <a-radio-group v-decorator="['autoPhrasesStatus', { initialValue: 1 }]">
                <a-radio :value="1">开启</a-radio>
                <a-radio :value="2">关闭</a-radio>
              </a-radio-group>
              <a-radio-group
                v-decorator="['autoPhrasesEffectScope', { initialValue: 0 }]"
                v-show="form.getFieldValue('autoPhrasesStatus') === 1"
              >
                <a-radio :value="0">全部开启</a-radio>
                <a-radio :value="1">仅老师发言</a-radio>
                <a-radio :value="2">仅用户发言</a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" :offset="1">黑名单</a-col>
            <a-col :span="17">
              <a-radio-group v-decorator="['blackStatus', { initialValue: 1 }]">
                <a-radio :value="1">开启</a-radio>
                <a-radio :value="2">关闭</a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" :offset="1">白名单</a-col>
            <a-col :span="17">
              <a-radio-group v-decorator="['whiteStatus', { initialValue: 1 }]">
                <a-radio :value="1">开启</a-radio>
                <a-radio :value="2">关闭</a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item label="人工审核模式配置">
          <a-radio-group
            v-decorator="['auditSendMode', { initialValue: 1, rules: [{ required: true, message: '请选择审核模式' }] }]"
          >
            <a-radio :value="1">先审后发</a-radio>
            <a-radio :value="2">先发后审</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="阿里云审核结果">
          <a-radio-group
            v-decorator="['aliyunAuditMode', { initialValue: 1, rules: [{ required: true, message: '请选择模式' }] }]"
          >
            <a-radio :value="1">参考值</a-radio>
            <a-radio :value="2">决定值</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="审核子账号">
          <a-checkbox-group v-model="newData.subaccountidArr" style="width: 100%">
            <a-checkbox
              v-for="item in childAccountList"
              :value="item.id"
              :key="item.id"
            >{{ item.username }}&nbsp;&nbsp;</a-checkbox
            >
          </a-checkbox-group>
        </a-form-item>
        <a-form-item label="消息保留天数">
          <a-radio-group v-model="newData.keepHistoryDay">
            <a-radio value="7">7天</a-radio>
            <a-radio value="14">14天</a-radio>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      :title="newauth?'新增审核权限':'修改审核权限'"
      width="768px"
      :visible="authvisible"
      @ok="saveAuthConfig"
      @cancel="authcancel"
    >
      <a-form-model
        ref="ruleForm"
        :model="authForm"
        :rules="authRules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item
          prop="name"
          label="内容名称:"
        >
          <a-input v-model="authForm.name" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item
          prop="businessId"
          label="所属业务:"
        >
          <a-select class="select" v-model="authForm.businessId">
            <a-select-option value="">--请选择所属业务--</a-select-option>
            <a-select-option v-for="item in bussdepTypeFilter" :value="item.key*1" :key="item.key">{{ item.value }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          prop="callback"
          label="回调地址:"
        >
          <a-input v-model="authForm.callbackUrl" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item
          prop="secret"
          label="秘钥:"
        >
          <a-input v-model="authForm.secret" placeholder="请输入" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal
      title="人员权限"
      width="768px"
      :visible="empvisible>0"
      @ok="saveEmployee"
      @cancel="closeEmployee"
    >
      <a-form-model
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item
          label="事业部:"
        >
          <a-select class="select" v-model="orgId" @change="getTargetKeys">
            <a-select-option value="">--请选择事业部--</a-select-option>
            <a-select-option v-for="item in businssDept" :value="item.id" :key="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          label="权限人员:"
        >
          <a-transfer
            :data-source="childList"
            show-search
            :filter-option="filterOption"
            :target-keys="targetKeys"
            :render="item => item.title"
            :list-style="{
              width: '210px',
              height: '300px',
            }"
            @change="handleChange"
            @search="handleSearch"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
// import Config from "../../utils/config";
// import UserRouteTool from "../../utils/userRouteTool";
import { mapGetters } from 'vuex'
import { timeFix } from '@/utils/util'
import { bussdepType, filterBussdepType } from '@/config/public'
import { subaccountlist, listsub, addConfig, editConfig , saveConfigEgc,getEgcConfigList,getEgcConfigUserList,saveAuthConfig} from '@/api/account'
import { depList, configmanageList } from '@/api/common'
import customConfig from './components/customConfig'
const bussdepTypeFilter = bussdepType.filter(item => item.key === '6' || item.key === '7')
// const currentBussList = ['2','6','7','12','13']
const currentBussList = ['1']
var newData = {
  name: '',
  bussdepType: '',
  auditType: '',
  callbackurl: '',
  secret: '',
  status: '',
  subaccountidArr: [],
  getlabelurl: '',
  // blackStatus: '2',
  // whiteStatus: '2',
  bussdepId: '',
  keepHistoryDay: '7',
  auditSendMode: 1
  // keyWordStatus:"2",
  // keyWordWhiteStatus:"2"
}
export default {
  name: 'BasicConfig',
  components: {customConfig},
  data() {
    return {
      bussdepTypeFilter,
      searchData: {
        bussdepid: '',
        status: ''
      },
      bussdepType: bussdepType.filter(item => currentBussList.includes(item.key)),
      filterType: filterBussdepType,
      showPass: true,
      newData: newData,
      loading: false,
      rejectReason: '',
      visible: false,
      visible1: false,
      modifyId: -1,
      businssDept: [],
      childAccountList: [],
      // childAccountListBack:[],
      businssDeptId: '',
      userList: [],
      userListBack: [],


      // 权限配置{title:'内容名称',dataIndex:'name'}
      columns:[
        {title: 'ID', dataIndex: 'id'},
        {title: '名称', dataIndex: 'name',scopedSlots: {customRender: 'name'}},
        {title: '回调地址', dataIndex: 'callbackUrl'},
        {title: '操作', dataIndex: 'operate', scopedSlots: {customRender: 'operate'}}
      ],
      authList:[],
      authloading:false,
      authvisible:false,
      empvisible:0,
      newauth:true,
      authData:[],
      targetKeys:[],
      authForm:{
        id:'',
        name:'',
        businessId:'',
        callbackUrl:'',
        secret:'',
      },
      authRules:{
        name:[
          {required:true,message:'必须填写内容名称',trigger:'blur'},
          {max:20,message:'内容长度不能超过20字符',trigger:'blur'}
        ],
        // orgId: [
        //   { required: true, message: '必须选择事业部', trigger: 'change' }
        // ],
        businessId: [
          { required: true, message: '必须选择业务', trigger: 'change' }
        ]
      },
      childList:[],
      pageObj: {
        current: 1,
        pageSize: 10,
        total: 1,
        changeLimitNum: false
      },
      noshowempid:[],
      orgId:'',
      configId:''
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this)
  },
  created() {},
  computed: {},
  mounted() {
    if (window.environment == 'bz') {
      this.bussdepType = bussdepType.filter(item => item.value === '投教')
    }
    depList().then(res => {
      if (res.code == 1) {
        if (window.environment == 'bz') {
          this.businssDept = res.result.filter(item => item.name == '博众事业部')
        } else {
          this.businssDept = res.result
        }
      }
    })

    this.getchildAccountList()
    this.getUserList()
    this.getAuthList()
  },
  methods: {
    ...mapGetters(['userInfo']),
    cancelHandle() {
      this.visible = false
      this.form.resetFields()
    },
    edit(scope) {
      subaccountlist({ configid: scope.id }).then(res => {
        if (res.code == 1) {
          this.modifyId = scope.id
          scope.subaccountidArr = []
          this.newData = JSON.parse(JSON.stringify(scope))
          this.newData.bussdepType = String(this.newData.bussdepType)
          this.newData.auditType = String(this.newData.auditType)
          // this.newData.blackStatus = String(this.newData.blackStatus)
          // this.newData.whiteStatus = String(this.newData.whiteStatus)
          this.newData.keepHistoryDay = String(this.newData.keepHistoryDay)

          // this.newData.keyWordStatus = String(this.newData.keyWordStatus)
          // this.newData.keyWordWhiteStatus = String(this.newData.keyWordWhiteStatus)
          if (res.result && res.result instanceof Array) {
            res.result.forEach(item => {
              this.newData.subaccountidArr.push(item.id)
            })
          }

          var tmpAccountIds = []
          for(let i=0;i<this.childAccountList.length;i++){
            tmpAccountIds.push(this.childAccountList[i].id)
          }
          var tmpnoshow =[]
          for(let i=0;i<this.newData.subaccountidArr.length;i++){
            if(tmpAccountIds.indexOf(this.newData.subaccountidArr[i])<0){
              tmpnoshow.push(this.newData.subaccountidArr[i])
            }
          }
          this.noshowempid = tmpnoshow


          this.visible = true
          this.$nextTick(() => {
            this.form.setFieldsValue({
              aliyunAuditMode: scope.aliyunAuditMode,
              auditSendMode: scope.auditSendMode,
              aliyunAuditStatus: scope.aliyunAuditStatus,
              blackStatus: scope.blackStatus,
              whiteStatus: scope.whiteStatus,
              keyWordStatus: scope.keyWordStatus,
              keyWordWhiteStatus: scope.keyWordWhiteStatus,
              autoPhrasesStatus: scope.autoPhrasesStatus,
              // blackEffectScope: scope.blackEffectScope,
              // whiteEffectScope: scope.whiteEffectScope,
              keywordEffectScope: scope.keywordEffectScope,
              keywordwhiteEffectScope: scope.keywordwhiteEffectScope,
              autoPhrasesEffectScope: scope.autoPhrasesEffectScope,
              aliyunAuditEffectScope: scope.aliyunAuditEffectScope
            })
          })
        }
      })
    },
    getchildAccountList() {
      listsub({ status: 1 }).then(res => {
        if (res.code == 1) {
          this.childAccountList = res.result

          var list = res.result
          var tmpList = []
          for(var i=0;i<list.length;i++){
            var item = list[i]
            tmpList.push({
              key:item.id,
              title:`${item.username}(${item.phone.substr(0,3)}****${item.phone.substr(item.phone.length-3,item.phone.length)})`
            })
          }
          this.childList = tmpList
        }
      })
    },
    getUserList() {
      configmanageList().then(res => {
        if (res.code == 1) {
          this.userList = res.result
          this.userListBack = JSON.parse(JSON.stringify(res.result))
        }
      })
    },
    addData() {
      this.newData = JSON.parse(JSON.stringify(newData))
      this.visible = true
      this.modifyId = -1
    },
    filterApps(id) {
      var str = ''
      this.businssDept.forEach(item => {
        if (item.id == id) {
          str = item.name
        }
      })
      return str
    },
    filterStatus(item) {
      if (item == '1') {
        return '审核'
      } else if (item == '2') {
        return '质检'
      }
    },
    handleOk() {
      this.form.validateFields((errors, values) => {
        if (errors) return
        if (!this.newData.name) {
          this.$message.error('名称不为空')
          return
        }
        if (!this.newData.bussdepType) {
          this.$message.error('所属业务不为空')
          return
        }
        if (!this.newData.auditType) {
          this.$message.error('审核类型不为空')
          return
        }
        // if (!this.newData.callbackurl) {
        //   this.$message.error("回调URL不为空")
        //   return
        // }
        if (!this.newData.secret) {
          this.$message.error('secret不为空')
          return
        }
        this.newData.subaccountId = this.newData.subaccountidArr.join(',')
        // if (this.userInfo().role != 'ROLE_SYSTEM') {
        this.newData.bussdepId = this.userInfo().bussdepId
        // }
        let api = addConfig
        if (this.modifyId != -1) {
          this.newData.configId = this.newData.id
          api = editConfig
        }
        const params = { ...this.newData, ...values }

        if(this.noshowempid&&this.noshowempid.length>0){
          var tmpArr = params.subaccountidArr
          tmpArr = tmpArr.concat(this.noshowempid)
          params.subaccountidArr = tmpArr
          params.subaccountId = params.subaccountidArr.join(',')
        }

        api(params).then(res => {
          if (res.code == 1) {
            this.$message.success(this.modifyId == -1 ? '新增成功' : '修改成功')
            this.visible = false
            this.form.resetFields()
            this.getUserList()
          }
        })
      })
    },

    // 权限配置
    getAuthList(){
      var params = {
        pageSize: this.pageObj.pageSize,
        page: this.pageObj.current,
      }
      getEgcConfigList(params).then(res=>{
        if(res.code==1&&res.result){
          this.authList = res.result.list


          this.pageObj.current = res.result.page.index
          this.pageObj.total = res.result.page.total
        }else{
          this.authList = []
        }
      })
    },
    // 页面改版的时候
    changePage: function (current, pageSize) {
      if (this.pageObj.changeLimitNum) {
        this.pageObj.current = 1
        this.pageObj.changeLimitNum = false
      }
      else {
        this.pageObj.current = current
      }
      this.pageObj.pageSize = pageSize
      this.getAuthList()
    },
    // 页面分页改变的时候
    changeLimitNum: function (current, pageSize) {
      this.pageObj.current = 1
      this.pageObj.pageSize = pageSize
      this.pageObj.changeLimitNum = true
      this.changePage(current, pageSize)
    },
    addauth(){
      this.newauth = true
      this.authForm={
        id:'',
        name:'',
        businessId:'',
        callbackUrl:'',
        secret:'',
      }
      this.targetKeys =[]
      this.authvisible = true
    },
    configauth(item){
      this.targetKeys = []
      this.orgId = ''
      this.configId = ''
      this.nowConfig = item
      this.empvisible = item.id
    },
    getTargetKeys(){
      var configList,id
      for(let i=0;i<this.authList.length;i++){
        if(this.authList[i].id==this.empvisible){
          configList = this.authList[i].configList
        }
      }
      if(configList&&configList.length>0){
        for(let i=0;i<configList.length;i++){
          if(configList[i].orgId==this.orgId){
            id = configList[i].id
            break
          }
        }
      }

      if(id&&id>0){
        this.configId = id
        getEgcConfigUserList({configId:id}).then(res=>{
          if(res.code==1){
            var ids = []
            for(var i=0;i<res.result.length;i++){
              ids.push(res.result[i].userId)
            }
            this.targetKeys = ids
          }
        })
      }else{
        this.targetKeys = []
      }
    },
    editauth(item){
      //编辑
      this.nowConfig = item
      this.authForm = {...item}
      this.authvisible = true
    },
    closeEmployee(){
      this.empvisible = false
    },
    authcancel() {
      this.authvisible = false
    },
    saveAuthConfig(){
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          var params = {...this.authForm}
          if(params.id==''||params.id==0){
            delete params.id
          }
          saveAuthConfig(params).then(res=>{
            if(res.code==1){
              var msg = this.newauth?'新建成功':'编辑成功'
              msg+=',请点击配置权限进行人员配置'
              this.$message.success(msg)
              this.getAuthList()
              this.authcancel()
            }
          })
        }
      })
    },
    submit(){
      // 提交保存
      if(this.authloading){
        return
      }
      if(this.targetKeys.length<=0){
        this.$message.error('请选择需要配权限的账号')
        return
      }
      if(this.targetKeys.length<=0){
        this.$message.error('请选择需要配权限的账号')
        return
      }
      this.authloading = true
      var params= {
        ...this.authForm,
        userIds:this.targetKeys.join(',')
      }
      if(params.id==''){
        delete params.id
      }

      var msg = this.newauth?'新建成功':'修改成功'
      saveConfigEgc(params).then(res=>{
        if(res.code==1){
          this.$message.success(msg)
          this.authcancel()
          this.getAuthList()
        }else{
          this.$message.error(res.message)
        }
        this.authloading = false
      })
    },
    saveEmployee(){
      if(this.orgId==''){
        this.$message.error('请选择需要配权限的事业部')
        return
      }
      if(this.targetKeys.length<=0){
        this.$message.error('请选择需要配权限的账号')
        return
      }

      var params= {
        id:this.configId,
        orgId:this.orgId,
        userIds:this.targetKeys.join(','),
        name:this.nowConfig.name,
        businessId:this.nowConfig.businessId,
        settingId:this.nowConfig.id
      }
      if(params.id==''){
        delete params.id
      }

      saveConfigEgc(params).then(res=>{
        if(res.code==1){
          this.$message.success('人员权限配置成功')
          this.closeEmployee()
          this.getAuthList()
        }else{
          this.$message.error(res.message)
        }
      })

    },
    filterOption(inputValue, option) {
      return option.title.indexOf(inputValue) > -1
    },
    handleChange(targetKeys, direction, moveKeys) {
      this.targetKeys = targetKeys
    },
    handleSearch(dir, value) {
      console.log('search:', dir, value)
    }
  },
  watch: {
    businssDeptId: function(val) {
      if (val) {
        this.userList = this.userListBack.filter(item => item.bussdepId == val)
      } else {
        this.userList = this.userListBack
      }
    }
  },
  computed:{
    subList(){
      return this.childList
    }
  }
}
</script>

<style lang="less" scoped>
.headDiv {
  padding: 20px;
  /*margin: 10px;*/
}
.select {
  width: 200px;
}
.ant-form-item {
  margin-bottom: 0;
}
.operate{
  color: #1890FF;
  cursor: pointer;
}
.ant-tabs{
  /deep/.ant-tabs-bar{
  margin-bottom: 0;
}
.block_line{
  background-color: #f1f1f1;
  height:25px ;
}
}

</style>
